import { observable, action, computed } from 'mobx';
import { Ankets } from 'api';

class AnketsStore {
  @observable.ref _ankets = [];

  @observable fetchState;

  @observable _anketId;

  @observable activeFilter = 'action_required';

  @action.bound
  async getAnkets() {
    this.fetchState = 'pending';

    try {
      const response = await Ankets.getAnkets();
      this._ankets = response.data;
      this.fetchState = 'fulfilled';
    } catch (e) {
      this.fetchState = 'rejected';
    }
  }

  @action.bound
  setAnketId(anketId) {
    this._anketId = anketId;
  }

  @computed
  get anketId() {
    return this._anketId;
  }

  @action.bound
  setFilter(filter) {
    this.activeFilter = filter;
  }

  @computed
  get ankets() {
    if (this.activeFilter === 'all') {
      return this._ankets;
    }

    if (this.activeFilter === 'action_required') {
      return this._ankets.filter(anket => anket.hasDecision);
    }

    return this._ankets.filter(anket => anket.status === this.activeFilter.toUpperCase());
  }
}

const anketsStore = new AnketsStore();

export default anketsStore;
